module.exports = ":host {\n  display: block;\n}\n\n#input {\n  position: absolute;\n  opacity: 0;\n  margin: 0;\n  width: 1.25em;\n  height: 1.25em;\n}\n"